import React from "react"; 
import { Row, Col, Card, CardBody } from "reactstrap";
import { useQuery } from "react-query";
import { getVehicules } from "../../../Vehicules/services/vehiculeApi";
import { Badge, Spin } from "antd";
import { useTranslation } from "react-i18next";

const StatusVehicule = () => {
  const { isLoading, isError, error, data: vehicles } = useQuery("vehicules", getVehicules);
  const treatedCount = vehicles ? vehicles.filter((vehicle) => vehicle?.statut === "En service").length : 0;
  const pendingCount = vehicles ? vehicles.filter((vehicle) => vehicle?.statut === "Hors service").length : 0;
  const archivedCount = vehicles ? vehicles.filter((vehicle) => vehicle?.statut === "En réparation").length : 0;
const {t}=useTranslation();
  return (
      <Row>
           <Card style={{ borderRadius: '15px' }}>
          <CardBody>
            <Row style={{ color: '#252525', fontFamily: 'Raleway', fontWeight: 'bold', fontSize: '16px' }}>
             {t("dashboard.statusOfVehicle")}
            </Row>
            
            <Row style={{ marginTop: '20px' }}>
              <Col lg={10} style={{color: '#434343', fontFamily: 'Inter', fontSize: '13px', fontWeight: '500px' }}>
                <Badge color="#2FB550" text= {t("dashboard.enService")} />
              </Col>
              <Col lg={2} style={{ display: 'flex', justifyContent: 'flex-end', color: '#252525', fontFamily: 'Inter', fontSize: '15px', fontWeight: 'bold' }}>
                { isLoading ? <Spin/> : treatedCount}
              </Col>
            </Row>
            <hr style={{ marginTop: '10px' }} />

            <Row style={{ marginTop: '20px' }}>
              <Col lg={10} style={{color: '#434343', fontFamily: 'Inter', fontSize: '13px', fontWeight: '500px' }}>
                <Badge color="#FF2D55" text={t("dashboard.horsService")} />
              </Col>
              <Col lg={2} style={{ display: 'flex', justifyContent: 'flex-end', color: '#252525', fontFamily: 'Inter', fontSize: '15px', fontWeight: 'bold' }}>
                { isLoading ? <Spin/> : pendingCount}
              </Col>
            </Row>
            <hr style={{ marginTop: '10px' }} />

            <Row style={{ marginTop: '20px' }}>
              <Col lg={10} style={{color: '#434343', fontFamily: 'Inter', fontSize: '13px', fontWeight: '500px' }}>
                <Badge color="#FF9500" text={t("dashboard.enReparation")}/>
              </Col>
              <Col lg={2} style={{ display: 'flex', justifyContent: 'flex-end', color: '#252525', fontFamily: 'Inter', fontSize: '15px', fontWeight: 'bold' }}>
                { isLoading ? <Spin/> : archivedCount}
              </Col>
            </Row>
            <hr style={{ marginTop: '10px' }} />

            <div className="d-flex align-items-center">
              <div style={{ fontSize: '21px', fontWeight: 'bold', fontFamily: 'Inter', marginRight: '10px',color:'#252525' }}>
                {isLoading ? <Spin/> : vehicles?.length }
              </div>
              <div style={{color: '#787878', fontFamily: 'Inter', fontSize: '13px', fontWeight: '500px' }} >{t("dashboard.totalVehicle")}</div>
            </div>
          </CardBody>
        </Card>
      </Row>
  );
};

export default StatusVehicule;
